import Request from '@/services/requests'
import Employee from '@/services/employees'

import {objectToCamelCase} from '../utils'

import PayoutAPI from './api'
import options from './options'

export default class Payout {
  static api = PayoutAPI.create(Payout)
  static options = options
  static readOnlyFields = ['id', 'requestRef', 'amount', 'currency', 'status']

  constructor(json) {
    Object.assign(this, {...json})
  }

  // constructor({
  //   id = '',
  //   requestRef,
  //   employeeRef,
  //   amount,
  //   employeeReceivedSinceReset,
  //   currency,
  //   status,
  //   employeeInactive,
  //   datetimeCreated,
  // } = {}) {
  //   Object.assign(this, {
  //     id,
  //     requestRef: requestRef ? Request.create(requestRef) : null,
  //     employeeRef: employeeRef ? Employee.create(employeeRef) : null,
  //     amount,
  //     employeeReceivedSinceReset,
  //     currency,
  //     status,
  //     employeeInactive,
  //     datetimeCreated,
  //   })
  // }

  static create(opts) {
    return new Payout(opts)
  }

  static fromAPI(json) {
    return new Payout(objectToCamelCase(json))
  }
}
